import { render, staticRenderFns } from "./MProcessFolder.vue?vue&type=template&id=ca920888&"
import script from "./MProcessFolder.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MProcessFolder.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MProcessFolder.vue?vue&type=style&index=0&id=ca920888&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports